(function ($) {
  let tabs = $(".js-tab-menu"); // tabのクラスを全て取得し、変数tabsに配列で定義
  $(".js-tab-menu").on("click", function() { // tabをクリックしたらイベント発火
    $(".is-active").removeClass("is-active"); // activeクラスを消す
    $(this).addClass("is-active"); // クリックした箇所にactiveクラスを追加
    const index = tabs.index(this); // クリックした箇所がタブの何番目か判定し、定数indexとして定義
    $(".js-tab-content").removeClass("is-show").eq(index).addClass("is-show"); // showクラスを消して、contentクラスのindex番目にshowクラスを追加
  })
})(jQuery);